export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  ENTRIES: '/entries',
  ENTRY_DETAIL: '/entries/:id',
  CREATE_ENTRY: '/entries/new',
  EDIT_ENTRY: '/entries/:id/edit',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  SHARES: '/shares',
  ANALYTICS: '/analytics',
};

export const MOODS = [
  { emoji: '😊', label: 'Happy', color: 'text-yellow-500' },
  { emoji: '😢', label: 'Sad', color: 'text-blue-500' },
  { emoji: '😡', label: 'Angry', color: 'text-red-500' },
  { emoji: '😴', label: 'Tired', color: 'text-purple-500' },
  { emoji: '🤔', label: 'Thoughtful', color: 'text-gray-500' },
  { emoji: '😍', label: 'Excited', color: 'text-pink-500' },
  { emoji: '😰', label: 'Anxious', color: 'text-orange-500' },
  { emoji: '😌', label: 'Peaceful', color: 'text-green-500' },
];

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const ENTRY_FILTERS = {
  ALL: 'all',
  PINNED: 'pinned',
  SHARED: 'shared',
  RECENT: 'recent',
};
